import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "gfu-btn-actions _my-3 _gap-1" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "gfu-grid gfu-grid--small"
}
const _hoisted_4 = { class: "gfu-field__label gfu-field__label--big gfu-grid__cell gfu-1of1 gfu-1of3--m gfu-1of4--l _tal" }
const _hoisted_5 = {
  key: 0,
  class: "gfu-field__value gfu-field__value--big gfu-grid__cell gfu-1of1 gfu-2of3--m gfu-3of4--l _tal",
  "data-qa": "order-details:Shipping"
}
const _hoisted_6 = {
  key: 1,
  class: "gfu-grid gfu-grid--small"
}
const _hoisted_7 = { class: "gfu-field__label gfu-field__label--big gfu-grid__cell gfu-1of1 gfu-1of3--m gfu-1of4--l _tal" }
const _hoisted_8 = {
  class: "gfu-field__value gfu-field__value--big gfu-grid__cell gfu-1of1 gfu-2of3--m gfu-3of4--l _tal",
  "data-qa": "order-details:OrderNotes"
}
const _hoisted_9 = { class: "_ma-0 _whs-pw" }
const _hoisted_10 = {
  key: 2,
  class: "gfu-grid gfu-grid--small"
}
const _hoisted_11 = { class: "gfu-field__label gfu-field__label--big gfu-grid__cell gfu-1of1 gfu-1of3--m gfu-1of4--l _tal" }
const _hoisted_12 = { class: "gfu-field__value gfu-field__value--big gfu-grid__cell gfu-1of1 gfu-2of3--m gfu-3of4--l _tal" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      ($options.isAddMoreButtonVisible)
        ? (_openBlock(), _createBlock(_component_tooltip, {
            key: 0,
            enabled: $props.isOrderLocked,
            text: $options.lockedOrderTooltipMessage
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_button, {
                theme: "primary",
                disabled: $props.isOrderLocked,
                class: "gfu-btn-actions__item",
                display: "fixed",
                onClick: $options.addItems,
                "data-qa": "your-pledge-button:AddItems"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.AddMoreButton), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled", "onClick"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["enabled", "text"]))
        : _createCommentVNode("v-if", true),
      ($options.isEditPledgeButtonVisible)
        ? (_openBlock(), _createBlock(_component_tooltip, {
            key: 1,
            enabled: $props.isOrderLocked,
            text: $options.lockedOrderTooltipMessage
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_button, {
                theme: "primary",
                disabled: $props.isOrderLocked,
                class: "gfu-btn-actions__item",
                display: "fixed",
                onClick: _withModifiers($options.editPledge, ["prevent"]),
                "data-qa": "project-user-pledge-button:EditPledge"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.EditPledgeButton), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled", "onClick"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["enabled", "text"]))
        : _createCommentVNode("v-if", true)
    ]),
    ($options.isDetailedInfoVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($props.orderDetails.shippingModel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.Resources.YourPledge.ShippingInfoLabel), 1 /* TEXT */),
                ($props.orderDetails)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_5, _toDisplayString($options.shippingInfo), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          ($props.orderDetails && $props.orderDetails.orderStateNotes && $props.orderDetails.orderStateNotes.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.Resources.YourPledge.NotesLabel), 1 /* TEXT */),
                _createElementVNode("label", _hoisted_8, [
                  _createElementVNode("pre", _hoisted_9, _toDisplayString($props.orderDetails.orderStateNotes), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($props.orderDetails && $props.orderDetails.invoices && _ctx.projectContext.project.enableInvoicing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.Resources.YourPledge.InvoicesLabel), 1 /* TEXT */),
                _createElementVNode("label", _hoisted_12, [
                  ($props.orderDetails.invoices.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.validInvoices, (invoice, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: `link-${index}`
                          }, [
                            (index > 0)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: `comma-${index}`
                                }, ", "))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("a", {
                              href: "",
                              onClick: _withModifiers($event => ($options.downloadInvoice(invoice)), ["prevent"]),
                              "data-qa": "order-details:Invoice"
                            }, _toDisplayString(invoice.invoiceNumber), 9 /* TEXT, PROPS */, _hoisted_14)
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.Resources.YourPledge.NoInvoicesText), 1 /* TEXT */))
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}